/**
 * We are using @emotion/react package to help us style individual partner tiers without the need
 * to create multiple css classes programmatically.
 */
import React from 'react'

import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'
import { contrastColor } from 'contrast-color'

const PartnerTierLabel = ({ partnerTier }) => {
  return (
    <div>
      <Tooltip title={partnerTier.description} arrow>
        <Chip
          data-testid="tier-label"
          css={{
            backgroundColor: `#${partnerTier.hexColor}`,
            color: contrastColor({ bgColor: `#${partnerTier.hexColor}` }),
          }}
          label={partnerTier.name}
        />
      </Tooltip>
    </div>
  )
}

export default PartnerTierLabel
